import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('/dashboard/notification/', 'notification');

tbl.add(new Xtc('created_at.$date', 'Date').renderSlot('date'))
tbl.add(new Xtc('title', 'Title').renderSlot('title'))
tbl.add(new Xtc('description', 'Description').renderSlot('description'))
tbl.add(new Xtc('is_read', 'Read').renderSlot('read'))

export default tbl;

